import * as React from 'react'
import { useCallback } from 'react'
import {
  IOption,
  iOptionEqualityComparer,
  IPropsWithProvider,
  OptionDependency,
} from '../../typings'

import { LightTooltip, AutoCompleteInput } from '@sales-center/components'
import AutoComplete, {
  AutocompleteChangeReason,
} from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'

interface Props extends IPropsWithProvider {
  value: IOption[]
  setValue: (value: IOption[]) => void
  dependsOn?: OptionDependency
}

export const MultiSelectAutoComplete: React.FC<Props> = ({
  value,
  setValue,
  dependsOn,
  component: Component,
}) => {
  const onChangeHandler = useCallback(
    (
      _e: React.ChangeEvent<unknown>,
      value: IOption[],
      _reason: AutocompleteChangeReason,
    ) => setValue(value),
    [setValue],
  )

  return (
    <Component
      dependsOn={dependsOn}
      render={(options, loading, enableGroup) => (
        <AutoComplete
          multiple
          loading={loading}
          disabled={loading}
          options={options}
          onChange={onChangeHandler}
          value={value}
          filterSelectedOptions
          getOptionDisabled={(o: IOption) => o.disabled ?? false}
          getOptionLabel={(o: IOption) => o.label}
          isOptionEqualToValue={iOptionEqualityComparer}
          groupBy={enableGroup ? (o) => o.group ?? '' : undefined}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )
          }}
          renderInput={(params) => (
            <AutoCompleteInput loading={loading} {...params} />
          )}
          renderTags={(value: IOption[], getTagProps) =>
            value.map((v, index) => {
              const label =
                v.group && enableGroup ? `${v.group}: ${v.label}` : v.label
              return (
                <LightTooltip key={index} title={label}>
                  <Chip
                    label={label}
                    color="primary"
                    {...getTagProps({ index })}
                  />
                </LightTooltip>
              )
            })
          }
        />
      )}
    />
  )
}
